import React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import DaumPostcode from 'react-daum-postcode'
import { adminRadii, adminShadows } from '../theme/adminTokens'

const ADDRESS_SEARCH_MODAL_SX = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: 'calc(100vw - 32px)', sm: 440 },
    maxWidth: '100%',
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: `${adminRadii.surface}px`,
    boxShadow: adminShadows.modal,
    outline: 'none',
    overflow: 'hidden',
    p: { xs: 1.5, sm: 2 },
}

// DaumPostcode 모달 껍데기를 공통화해 등록/수정 화면의 주소 검색 UI 기준을 맞춘다.
export default function AddressSearchModal({ open, onClose, onComplete }) {
    return (
        <Modal open={open} onClose={onClose} aria-label="주소 검색">
            <Box sx={ADDRESS_SEARCH_MODAL_SX}>
                <DaumPostcode autoClose onComplete={onComplete} />
            </Box>
        </Modal>
    )
}
